export const formStructure = [
  [
    {
      name: 'titulo',
      label: 'Titulo',
      type: 'text',
      component: 'FormField',
      placeholder: 'Digite o titulo do acompanhamento',
      colProps: { md: 12 },
      maxLength: 200,
      validation: {
        required: 'Titulo e obrigatorio',
      },
    },
  ],
  [
    {
      name: 'descricao',
      label: 'Descricao',
      type: 'textarea',
      component: 'Textarea',
      placeholder: 'Digite a descricao do acompanhamento',
      colProps: { md: 8 },
      rows: 4,
      validation: {
        required: 'Descricao e obrigatoria',
      },
    },
    {
      name: 'acompanhamentoInterno',
      label: 'Acompanhamento Interno',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 4 },
    },
  ],
  [
    {
      name: 'depotId',
      label: 'Container (Depot)',
      component: 'SearchSelect',
      placeholder: 'Digite para buscar um container...',
      colProps: { md: 12 },
      minSearchLength: 1,
      maxResults: 10,
      onSearch: null,
    },
  ],
];

export const formSections = (initialValues) => [
  {
    title: 'Dados do Acompanhamento',
    rows: [0, 1, 2],
  },
];

export const validateForm = (values) => {
  const errors = {};

  if (!values.titulo || values.titulo.trim().length === 0) {
    errors.titulo = 'Titulo e obrigatorio';
  }

  if (!values.descricao || values.descricao.trim().length === 0) {
    errors.descricao = 'Descricao e obrigatoria';
  }

  return errors;
};
